export default __webpack_public_path__ + "static/media/kneeCoronalMovement.5cd79bc0.png";